/* guard to check if a user is logged in */

import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {UserService} from "../../services/user.service";
import {map, of, take} from "rxjs";

export const authGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService)
  const router = inject(Router)
  return of(userService.user()).pipe(
    take(1),
    map(user => {
      const isAuth = !!user
      if (isAuth) {
        return true
      }
      return router.createUrlTree(['/login'])
    })
  );
};
